// eslint-disable-next-line import/prefer-default-export
export const calculateProgressValue = (
  currentPage,
  totalPages,
  submissionPageNumber
) => {
  if (typeof submissionPageNumber === 'number') {
    return Math.round((100 / (submissionPageNumber + 1)) * currentPage);
  }

  return Math.round((100 / totalPages) * currentPage);
};

export const StageStatus = {
  INCOMPLETE: 'INCOMPLETE',
  COMPLETED: 'COMPLETED',
  CURRENT: 'CURRENT',
};

export const buildStages = (
  postcodePageNumber,
  finishPageNumber,
  pageNumbers
) => {
  const startPageNumber = 0;

  const contactInfoPageNumbers = postcodePageNumber
    ? pageNumbers.filter(
        (pageNumber) =>
          pageNumber >= postcodePageNumber && pageNumber < finishPageNumber
      )
    : [];

  const requirementsPageNumbers = pageNumbers.filter(
    (pageNumber) =>
      pageNumber !== startPageNumber &&
      pageNumber < (postcodePageNumber || finishPageNumber)
  );

  return [
    {
      id: 'start',
      label: 'Get Started',
      pages: [startPageNumber],
      status: StageStatus.CURRENT,
    },
    {
      id: 'requirements',
      label: 'Your Requirements',
      pages: requirementsPageNumbers,
      status: StageStatus.INCOMPLETE,
    },
    {
      id: 'contactInfo',
      label: 'Your Contact Info',
      pages: contactInfoPageNumbers,
      status: StageStatus.INCOMPLETE,
    },
    {
      id: 'finish',
      label: 'Finish',
      pages: [finishPageNumber],
      status: StageStatus.INCOMPLETE,
    },
  ];
};
